import React, {useEffect, useRef, useState} from 'react';
import FormInput from "../../formComponents/FormInput";
import FormBlock from "../../formComponents/FormBlock";
import BaseSimpleItemEditorForm from "../BaseSimplePage/BaseSimpleItemEditorForm";
import FormUrlInput from "../../formComponents/FormUrlInput";
import FormCheckbox from "../../formComponents/FormCheckbox";
import FormLinkedItemSelect from "../../formComponents/FormLinkedItemSelect";
import {Button} from "@mui/material";
import ServerManager from "../../API/ServerManager";
import cl from "../../formComponents/FormImage.module.css"; // TODO extract independent style

const LocationsItemForm = ({initData, controlRef, setSnackbarData, setLoadingOverlayData}) => {

    const controlRefName = useRef(null);
    const controlRefShortName = useRef(null);
    const controlRefCity = useRef(null);
    const controlRefAddress = useRef(null);
    const controlRefUrl = useRef(null);
    /*const controlRefPrizes = useRef(null);*/
    const controlRefAccDataIncluded = useRef(null);
    const controlRefAccUrl = useRef(null);
    const controlRefAccWheelchair = useRef(null);
    const controlRefAccVisual = useRef(null);
    const controlRefAccHearing = useRef(null);
    const controlRefAccMental = useRef(null);
    const controlRefIsClosedForRenovation = useRef(null);
    const controlRefIsWithoutOwnStage = useRef(null);

    const fileInputRef = useRef(null);

    const [cultureRuDataIncluded, setCultureRuDataIncluded] = useState(getInitialCultureRuDataIncluded(initData));
    const [accDataIncluded, setAccDataIncluded] = useState(getInitialAccDataIncluded(initData));

    useEffect(() => {
        if (controlRef) {
            controlRef.current = {
                validate: validate,
                getData: getData,
            };
        }
    });

    function validate() {
        let isValid = true;

        if (!controlRefName.current.validateNotEmpty("Нужно указать название!"))
            isValid = false;

        if (!controlRefName.current.validateLength(255))
            isValid = false;

        if (!controlRefShortName.current.validateLength(255))
            isValid = false;

        if (!controlRefCity.current.validateIsSelected("Нужно выбрать город!"))
            isValid = false;

        if (!controlRefAddress.current.validateNotEmpty("Нужно указать адрес!"))
            isValid = false;

        if (!controlRefAddress.current.validateLength(500))
            isValid = false;

        if (!controlRefUrl.current.validateUrl("Неверно указан адрес сайта!"))
            isValid = false;

        if (!controlRefUrl.current.validateLength(2048))
            isValid = false;

        /*if (!controlRefPrizes.current.validate())
            isValid = false;*/

        if (cultureRuDataIncluded) {
            if (!validateAccUrl(controlRefAccUrl))
                isValid = false;
            else if (!controlRefAccUrl.current.validateLength(2048))
                isValid = false;

            if (accDataIncluded) {
                const allValid = validateAccDataAndCheckAllValid();
                if (!allValid) {
                    isValid = false;
                    controlRefAccDataIncluded.current.setErrorMessage("Нужно либо корректно заполнить ВСЕ идущие ниже дополнительные поля, либо убрать эту галку");
                }
                else {
                    controlRefAccDataIncluded.current.setErrorMessage("");
                }
            }
        }

        return isValid;
    }

    function validateAccDataAndCheckAllValid() {
        let allValid = true;

        if (!validateAccValue(controlRefAccWheelchair))
            allValid = false;
        if (!validateAccValue(controlRefAccVisual))
            allValid = false;
        if (!validateAccValue(controlRefAccHearing))
            allValid = false;
        if (!validateAccValue(controlRefAccMental))
            allValid = false;

        return allValid;
    }

    function getData() {
        return {
            name: controlRefName.current.getText(),
            short_name: controlRefShortName.current.getText(),
            city_id: controlRefCity.current.getSelectedId(),
            address: controlRefAddress.current.getText(),
            website_url: controlRefUrl.current.getUrl(),
            is_closed_for_renovation: controlRefIsClosedForRenovation.current.getChecked(),
            is_without_own_stage: controlRefIsWithoutOwnStage.current.getChecked(),
            accessibility: getAccData(),
        }
    }

    function getAccData() {
        if (!cultureRuDataIncluded)
            return null;

        const accData = {
            source_url: controlRefAccUrl.current.getUrl()
        }

        if (accDataIncluded) {
            accData.wheelchair = parseInt(controlRefAccWheelchair.current.getText());
            accData.visual_impairment = parseInt(controlRefAccVisual.current.getText());
            accData.hearing_impairment = parseInt(controlRefAccHearing.current.getText());
            accData.cognitive_impairment = parseInt(controlRefAccMental.current.getText());
        }

        return accData;
    }

    async function handleExportEvents() {
        setLoadingOverlayData({title:"Экспорт событий ..."})
        try {
            //await new Promise(resolve => setTimeout(resolve, 1000)); // temp!
            await ServerManager.exportLocationEvents(initData.id);
        } catch (error) {
            const msg = `Ошибка при экспорте событий: ${error}`;
            console.error(msg);
            setSnackbarData({severity: "error", title: msg});
        } finally {
            setLoadingOverlayData(null);
        }
    }

    async function handleImportEvents() {
        fileInputRef.current.click();
    }

    async function handleFileInputChange(event) {
        const file = event.target.files?.[0];
        if (!file)
            return;

        setLoadingOverlayData({title:"Импорт событий ..."})
        try {
            const base64 = await fileToBase64(file);
            //console.log(file.name, base64);
            const response = await ServerManager.importLocationEvents(initData.id, base64);
            setSnackbarData({severity: "success", message: `Успешно импортировано событий: ${response.imported}`});
        } catch (error) {
            const msg = `Ошибка при импорте событий: ${error}`;
            console.error(msg);
            setSnackbarData({severity: "error", title: msg});
        } finally {
            event.target.value = ""; // чтобы можно было выбрать тот же файл повторно
            setLoadingOverlayData(null);
        }
    }

    return (
        <BaseSimpleItemEditorForm>
            <FormBlock title="Основные">
                <FormInput
                    controlRef={controlRefName}
                    label="Название"
                    widthLimit={750}
                    initValue={initData?.name ?? ""}
                />
                <FormInput
                    controlRef={controlRefShortName}
                    label="Сокращенное название"
                    widthLimit={500}
                    initValue={initData?.short_name ?? ""}
                />
            </FormBlock>
            <FormBlock title="Местонахождение">
                <FormLinkedItemSelect
                    controlRef={controlRefCity}
                    label={"Город"}
                    widthLimit={500}
                    initSelectedId={initData?.city_id}
                    initRefList={initData?.refs?.cities}
                    apiName2="cities"
                    showIds={true}
                    renderItemExtraInfoFunc={renderCityItemExtraInfo}
                />
                <FormInput
                    controlRef={controlRefAddress}
                    label="Адрес"
                    widthLimit={500}
                    initValue={initData?.address ?? ""}
                    placeholder="ул. ?????, д. ??, стр. ??"
                />
            </FormBlock>
            <FormBlock title="Интернет">
                <FormUrlInput
                    controlRef={controlRefUrl}
                    label="Сайт (учреждения)"
                    widthLimit={500}
                    initValue={initData?.website_url ?? ""}
                    placeholder="https://..."
                />
            </FormBlock>
            {/*<FormBlock title="Инфо">
                <FormPrizeListSelect
                    controlRef={controlRefPrizes}
                    selectedItemsAreaType="column"
                    label="Награды"
                    inputWidthLimit={450}
                    selectedItemsAreaWidthLimit={700}
                    options={[]}
                    initPrizes={initData?.prizes ?? []}
                    showIds={true}
                />
            </FormBlock>*/}
            <FormBlock title="Данные на сайте культура.рф (culture.ru)">
                <FormCheckbox
                    controlRef={null}
                    label={"Имеются данные на сайте культура.рф (culture.ru)"}
                    initValue={getInitialCultureRuDataIncluded(initData)}
                    onSelect={setCultureRuDataIncluded}
                    tipText={"Поставьте галку, если об этой локации имеются данные на сайте культура.рф (culture.ru)"}
                />
                {cultureRuDataIncluded && <>
                    <FormUrlInput
                        controlRef={controlRefAccUrl}
                        label="Страница локации на культура.рф (culture.ru)"
                        widthLimit={500}
                        initValue={initData?.accessibility?.source_url ?? ""}
                        placeholder="https://www.culture.ru/..."
                        tipText={"Укажите адрес страницы на сайте culture.ru (или культура.рф), посвященной данной локации.\nНапример, страница  о \"МХТ им. А. П. Чехова\" имеет адрес: https://www.culture.ru/institutes/10492/moskovskii-khudozhestvennyi-teatr-im-a-p-chekhova"}
                    />
                    <FormCheckbox
                        controlRef={controlRefAccDataIncluded}
                        label={"Имеется информация о доступности для людей с особ. здоровья"}
                        initValue={getInitialAccDataIncluded(initData)}
                        onSelect={setAccDataIncluded}
                        tipText={"Поставьте галку, если на сайте культура.рф (culture.ru) для данной локации указана \"информация о доступности учреждения для людей с особенностями здоровья\", затем скопируйте эти данные в соответствующие поля ниже."}
                    />
                    {accDataIncluded && <>
                        <FormInput
                            controlRef={controlRefAccWheelchair}
                            label="Инвалиды-колясочники (доступность, %)"
                            widthLimit={100}
                            initValue={initData?.accessibility?.wheelchair ?? ""}
                            placeholder="%"
                        />
                        <FormInput
                            controlRef={controlRefAccVisual}
                            label="Нарушения зрения (доступность, %)"
                            widthLimit={100}
                            initValue={initData?.accessibility?.visual_impairment ?? ""}
                            placeholder="%"
                        />
                        <FormInput
                            controlRef={controlRefAccHearing}
                            label="Нарушения слуха (доступность, %)"
                            widthLimit={100}
                            initValue={initData?.accessibility?.hearing_impairment ?? ""}
                            placeholder="%"
                        />
                        <FormInput
                            controlRef={controlRefAccMental}
                            label="Ментальные нарушения (доступность, %)"
                            widthLimit={100}
                            initValue={initData?.accessibility?.cognitive_impairment ?? ""}
                            placeholder="%"
                        />
                    </>}
                </>}
            </FormBlock>
            <FormBlock title="Специальные">
                <FormCheckbox
                    controlRef={controlRefIsClosedForRenovation}
                    label="Закрыта на реновацию"
                    initValue={initData?.is_closed_for_renovation ?? false}
                />
                <FormCheckbox
                    controlRef={controlRefIsWithoutOwnStage}
                    label="Сцена отсутствует или на ремонте"
                    initValue={initData?.is_without_own_stage ?? false}
                    tipText={"Поставьте галочку, если у локации отсутствуют (постоянно или временно) собственные сцены и события проходят на сторонних сценах"}
                />
            </FormBlock>
            {initData && <FormBlock title="B2B">
                <div style={{display: "flex", gap: "10px"}}>
                    <FormButton label="Экспорт событий в Excel ..." onClick={handleExportEvents}/>
                    <FormButton label="Импорт событий из Excel ..." onClick={handleImportEvents}/>
                    <input
                        ref={fileInputRef}
                        className={cl.fileInput}
                        type="file"
                        accept=".xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                        onChange={handleFileInputChange}
                    />
                </div>
            </FormBlock>}
        </BaseSimpleItemEditorForm>
    );
};

const FormButton = ({label, onClick, sx}) => {
    return <Button variant="outlined" size="small" onClick={onClick} sx={sx}>{label}</Button>
}

function validateAccUrl(accUrlControlRef) {
    const url = accUrlControlRef.current.getUrl();
    if (!url) {
        accUrlControlRef.current.setErrorMessage("Необходимо указать адрес страницы (или снять галку, что \"Имеются данные на сайте культура.рф\")");
        return false;
    }

    //https://www.culture.ru/institutes/10492/moskovskii-khudozhestvennyi-teatr-im-a-p-chekhova (МХТ им. А. П. Чехова)
    const regex = /^https:\/\/(www\.)?(culture\.ru|культура\.рф)\/.+/i;

    if (!regex.test(url)) {
        accUrlControlRef.current.setErrorMessage("Указан неверный адрес. Правильный адрес должен начинаться с https://www.culture.ru/... или https://www.культура.рф/... Например, https://www.culture.ru/institutes/10492/moskovskii-khudozhestvennyi-teatr-im-a-p-chekhova");
        return false;
    }

    return true;
}

function validateAccValue(accControlRef) {
    if (checkAccValue(accControlRef.current.getText()))
        return true;

    accControlRef.current.setErrorMessage("Необходимо указать число от 0 до 100!");
    return false;
}

function checkAccValue(value) {
    if (!value || value.length === 0)
        return false;

    const intVal = parseInt(value, 10);
    if (isNaN(intVal) || intVal < 0 || intVal > 100)
        return false;

    return true;
}

function getInitialCultureRuDataIncluded(initData) {
    return Boolean(initData?.accessibility?.source_url);
}

function getInitialAccDataIncluded(initData) {
    return getInitialCultureRuDataIncluded(initData) &&
        (isDefined(initData.accessibility.wheelchair) ||
            isDefined(initData.accessibility.visual_impairment) ||
            isDefined(initData.accessibility.hearing_impairment) ||
            isDefined(initData.accessibility.cognitive_impairment));
}

function isDefined(value) {
    return value !== undefined && value !== null;
}

function renderCityItemExtraInfo(item, className, dataRefs) {
    if (item.is_region_city)
        return null;

    const regionTitle = dataRefs?.regions?.[item.region_id]?.name ?? "?";
    return <span className={className}>{regionTitle}</span>
}

// TODO? вынести
function fileToBase64(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
            // reader.result: "data:application/vnd...;base64,UEsDBBQABgAI..."
            resolve(reader.result.split(",")[1]);
        };
        reader.onerror = () => reject(reader.error);
        reader.readAsDataURL(file);
    });
}

export default LocationsItemForm;